import router from '@/router';
import store from '@/store';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
NProgress.configure({ showSpinner: false }); // NProgress Configuration
import { notification } from 'ant-design-vue';
import { getMenuFlattern } from '@/bone/layout/config';

const whiteList = ['/login', '/'];

//每次路由跳转前，开启进度条，获取token，并进行下面一系列操作
router.beforeEach((to, from, next) => {
  NProgress.start();
  // 如果不存在token则进行判断，是否url中存在token
  if (to.query.hasOwnProperty('token')) {
    store.commit('SET_TOKEN', to.query.token);
    next({ path: to.path });
  }
  // 获取token
  let token = store.getters.token;
  // 检测是否存在token
  let hasToken = !['undefined', '', undefined, null].includes(token);
  // 如果存在token
  if (hasToken) {
    // 判断是否在白名单下
    if ('/login' === to.path) {
      next({ path: '/' });
      NProgress.done();
    }
    // 如果不在白名单下，判断是否读取到了用户数据，如果没有则进行读取，如果有则放行
    if (['undefined', '', undefined, null].includes(store.getters.id)) {
      store
        .dispatch('GetUserInfo')
        .then((res) => {
          // 判断是否访问的/layout,如果是，则访问第一个子界面
          var menu_flattern = getMenuFlattern();
          if (!menu_flattern.some((menu) => menu.path === to.path)) {
            next({ path: menu_flattern[0].path });
          } else {
            next();
          }
        })
        .catch(() => {
          notification.error({
            message: '失败',
            description: '获取权限信息失败',
          });
          store.commit('CLEAR_TOKEN');
          next({ path: '/login' });
        });
    } else {
      // 判断是否访问的/layout,如果是，则访问第一个子界面
      var menu_flattern = getMenuFlattern();
      if (!menu_flattern.some((menu) => menu.path === to.path)) {
        next({ path: menu_flattern[0].path });
      } else {
        next();
      }
    }
  } else {
    // 判断是否在白名单下
    if (whiteList.includes(to.path)) {
      next();
    } else {
      notification.error({
        message: '失败',
        description: '没有检查到登录信息，将跳转到登录界面',
      });
      next('/login');
    }
    NProgress.done();
  }
});

//关闭进度条
router.afterEach(() => {
  NProgress.done(); // finish progress bar
});
